import React, {
    useEffect,
    useState,
    useMemo,
} from 'react';
import PropTypes from 'prop-types';
import {useRouteMatch} from 'react-router-dom';
import AffinityContext from "./AffinityContext";
import axios from "axios";

const products_dict_number = ["0", "1", "2", "3", "4", "5"]
const coberturaMotovehiculoInfo = {
    "names": {
        "RC": "Responsabilidad civil",
        "IT": "Incendio total",
        "IP": "Incendio parcial",
        "RHT": "Robo y/o hurto total",
        "RHP": "Robo y/o hurto parcial",
        "AT": "Accidente total"
    },
    "1": {
        "RC": true,
        "IT": false,
        "IP": false,
        "RHT": false,
        "RHP": false,
        "AT": false
    },
    "3": {
        "RC": true,
        "IT": true,
        "IP": true,
        "RHT": true,
        "RHP": false,
        "AT": false
    },
    "17": {
        "RC": true,
        "IT": true,
        "IP": false,
        "RHT": true,
        "RHP": false,
        "AT": true
    },
    "5": {
        "RC": true,
        "IT": true,
        "IP": true,
        "RHT": true,
        "RHP": true,
        "AT": true
    }
}

const AffinityContextProvider = ({
                                     children,
                                 }) => {
    const {params: {CodigoProductor, affinityId}} = useRouteMatch();

    const [affinityName, setAffinityName] = useState(null)
    const [affinityActive, setAffinityActive] = useState(null)
    const [affinityInterCode, setAffinityInterCode] = useState(null)
    const [affinityOrgCode, setAffinityOrgCode] = useState(null)
    const [affinityAdvisers, setAffinityAdvisers] = useState(null)
    const [affinityResponsable, setAffinityResponsable] = useState(null)
    const [affinityProducts, setAffinityProducts] = useState(null)
    const [affinityPic, setAffinityPic] = useState(null)
    const [affinityQR, setAffinityQR] = useState(null)
    const [affinityLink, setAffinityLink] = useState(null)
    const [adviserPhone, setAdviserPhone] = useState(null)
    const [productOtros, setProductOtros] = useState(null)
    const coveragesToFilter = ['38']

    // VEHICULO
    const [infoAuto, setInfoAuto] = useState(null)
    const [localidades, setLocalidades] = useState(null)

    // MOTOVEHICULO
    const [infoMoto, setInfoMoto] = useState(null)
    //HOGAR
    const [coberturasInfo, setCoberturasInfo] = useState(null);

    const [isReady, setIsReady] = useState(false);

    useEffect(() => {
        let shouldUpdate = true;

        const init = async () => {
            let url = process.env.REACT_APP_BACK_SERVER + '/consultarAfinidad'

            let data = {"idAfinidad": affinityId, "CodigoProductor": CodigoProductor}

            axios.post(url, data).then((resp) => {
                if (shouldUpdate) {
                    resp = resp['data']

                    let activated_products_num = [];
                    resp['Products'].map((prod, idx) => {
                        if (prod === 1) {
                            activated_products_num.push(products_dict_number[idx])
                        }
                    })

                    if(resp['TelefonoAsesorWapp'] !== null)
                        setAdviserPhone(resp['TelefonoAsesorWapp'])
                    else
                        setAdviserPhone(resp['Advisers'][0][1])
                    setAffinityActive(resp['Activa'])
                    setAffinityName(resp['Name'])
                    setAffinityInterCode(resp['InterCode'])
                    setAffinityOrgCode(resp['OrgCode'])
                    setAffinityAdvisers(resp['Advisers'])
                    setAffinityResponsable(resp['Responsable'])
                    setAffinityProducts(activated_products_num)
                    setAffinityPic(resp['Pic'])

                    let dict = {};
                    resp['coberturas'].map((item) =>
                        dict[item.NumeroCobertura] = {
                            sumaChica: item.SumaChica,
                            sumaMediana: item.SumaMediana,
                            sumaGrande: item.SumaGrande,
                            sumaMaxima: item.SumaMaxima,
                            obligatorio: item.Obligatorio,
                            sumaMinima: item.SumaMinima,
                            descripcion: item.Descripcion,
                            descripcionCompleta: item.DescripcionCompleta,
                        });
                    setCoberturasInfo(dict)
                    setAffinityQR(resp['QR'])
                    setAffinityLink(resp['Link'])
                    setInfoAuto(resp['InfoAuto'])
                    setInfoMoto(resp['InfoMoto'])
                    setLocalidades(resp['Localidades'])
                    setProductOtros(resp['productosOtros'].filter(product => product.Nombre !== "Motos"))
                    setIsReady(true);
                }
            });


        }
        init();
        return () => {
            /* This cleanup function is used to prevent updating the state
            when the component is unmounted */
            shouldUpdate = false;
        };
    }, [CodigoProductor, affinityId])


    const context = useMemo(() => ({
        affinityName,
        affinityActive,
        affinityInterCode,
        affinityOrgCode,
        affinityAdvisers,
        affinityResponsable,
        affinityProducts,
        affinityPic,
        affinityQR,
        affinityLink,
        affinityId,
        infoAuto,
        infoMoto,
        localidades,
        coberturasInfo,
        coberturaMotovehiculoInfo,
        adviserPhone,
        productOtros,
        coveragesToFilter,
        isReady
    }), [
        affinityName,
        affinityActive,
        affinityInterCode,
        affinityOrgCode,
        affinityAdvisers,
        affinityResponsable,
        affinityProducts,
        affinityPic,
        affinityQR,
        affinityLink,
        affinityId,
        infoAuto,
        infoMoto,
        localidades,
        coberturasInfo,
        coberturaMotovehiculoInfo,
        adviserPhone,
        productOtros,
        coveragesToFilter,
        isReady
    ]);

    return (
        <AffinityContext.Provider value={context}>
            {children}
        </AffinityContext.Provider>
    );
};

AffinityContextProvider.propTypes = {
    children: PropTypes.node.isRequired,
};

export default AffinityContextProvider;